export const FIND_MY_ORDER_NUMBER = "where do i find my order number?"

export const ORDER_STATUS = "order status"
